export function calculateAge(birthDateStr) {
    const birthDate = new Date(birthDateStr);
    const today = new Date();
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();
  
    if (days < 0) {
      months -= 1;
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }
    if (years > 0) {
      return years + " years old";
    } else if (months > 0) {
      return months + "mo " + days + "days old";
    } else {
      return days + " days old";
    }
}
export function calculateAgeInWeeks(birthDate) {
  if (!birthDate) return 'Unknown';

  const birth = new Date(birthDate);
  const today = new Date();

  const diffInMs = today - birth; // Doğum tarihinden bugüne kadar geçen süre (milisaniye cinsinden)
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24)); // Gün olarak hesapla
  const diffInWeeks = Math.floor(diffInDays / 7); // Haftaya çevir

  return diffInWeeks + " weeks";
}
export function formatDate(dateString) {
    try {
      const date = dateString?.toDate ? dateString.toDate() : new Date(dateString);
      if (isNaN(date)) throw new Error('Invalid date');
      return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      });
    } catch (error) {
      console.error('Geçersiz tarih formatı:', dateString);
      return 'Tarih bilgisi yok';
    }
}

export function parseDate(dateValue) {
    try {
      const date = dateValue?.toDate ? dateValue.toDate() : new Date(dateValue);
      return date.getTime();
    } catch {
      return 0;
    }
}
export function calculateAgeGroup(birthDateStr) {
  if (!birthDateStr) return 'Unknown';
  let birthDate;
  if (birthDateStr && typeof birthDateStr.toDate === 'function') {
    birthDate = birthDateStr.toDate();
  } else {
    birthDate = new Date(birthDateStr);
  }
  if (isNaN(birthDate)) return 'Unknown';
  
  const today = new Date();
  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  
  if (today.getDate() < birthDate.getDate()) {
    months -= 1;
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }
  
  const totalMonths = years * 12 + months;
  
  if (totalMonths <= 3) return '0-3 Months';
  if (totalMonths <= 6) return '3-6 Months';
  if (totalMonths <= 12) return '6-12 Months';
  if (years < 2) return '1-2 Years';
  if (years < 4) return '2-4 Years';
  if (years < 8) return '4-8 Years';
  return '8+ Years';
}
